import { render, staticRenderFns } from "./PaiemClitVendRetr.vue?vue&type=template&id=524862b0&scoped=true&"
import script from "./PaiemClitVendRetr.vue?vue&type=script&lang=js&"
export * from "./PaiemClitVendRetr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524862b0",
  null
  
)

export default component.exports